<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col cols="10" offset>
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile }"
          v-html="$t('submissionConfirmationCampaignList.title')"
        ></h1>
        <h3
          class="mb-3"
          :class="{ 'text-h6': isMobile }"
          v-html="$t('submissionConfirmationCampaignList.advertiserName') + ' : ' + advertiser.advertiserName"
        ></h3>
      </v-col>

      <v-col cols="2" class="text-right" v-if="!isMobile">
        <v-btn v-if="isCpmMode"
          color="light-blue darken-1 text-white"
          @click="clickCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignList')}}</v-btn>
        <v-btn v-else
          color="light-blue darken-1 text-white"
          @click="clickCampaignPeriod()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignPeriod')}}</v-btn>
      </v-col>
      <v-col cols="12" class="text-right" v-else>
        <v-btn v-if="isCpmMode"
          color="light-blue darken-1 text-white"
          @click="clickCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignList')}}</v-btn>
        <v-btn v-else
          color="light-blue darken-1 text-white"
          @click="clickCampaignPeriod()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignPeriod')}}</v-btn>
      </v-col>

      <v-col cols="12" v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col cols="6" md="6">
        <form>
          <label>
            <input
              type="radio"
              v-model="selectDeliveryStatus"
              name="delivery"
              value="1"
              @change.stop="changeDeliveyStatus()"
            />
            {{ $t('submissionConfirmationCampaignList.delivery.future') }} &nbsp;
          </label>
          <label>
            <input
              type="radio"
              v-model="selectDeliveryStatus"
              name="delivery"
              value="2"
              @change.stop="changeDeliveyStatus()"
            />
            {{ $t('submissionConfirmationCampaignList.delivery.now') }} &nbsp;
          </label>
          <label>
            <input
              type="radio"
              v-model="selectDeliveryStatus"
              name="delivery"
              value="3"
              @change.stop="changeDeliveyStatus()"
            />
            {{ $t('submissionConfirmationCampaignList.delivery.previous') }}
          </label>
        </form>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12">
        <v-data-table
          :headers="submissionConfirmationCampaignListHeaders"
          :items="campaignList"
          :no-data-text="$t('commons.table.no.data.text')"
          :hide-default-header="isMobile"
          hide-default-footer
          class="elevation-3 campaign-list"
          :class="{mobile: isMobile}"
          :sort-by="pagination.sortBy"
          :sortDesc="pagination.descending"
          :items-per-page="pagination.rowsPerPage"
          :loading="isSearching"
          v-model="checkTargetCampaignIds"
          show-select
          item-value="campaignId"
          :item-selectable="checkItemSelectable"
        >
          <template v-slot:item="{ item }" v-if="!isMobile">
            <tr>
              <td style="padding: 0;">
                <div class="d-flex justify-center align-center">
                  <v-checkbox
                    v-model="checkTargetCampaignIds"
                    :value="item.campaignId"
                    :disabled="!checkItemSelectable(item)"
                    hide-details
                  />
                </div>
              </td>
              <td class="text-left">
                {{ item.campaignName }}
              </td>
              <td class="text-right">
                {{ number_format(item.creativeLandingCount) }}
              </td>
            </tr>
          </template>
          <template v-slot:item="{ item }" v-if="isMobile">
            <tr>
              <td>
                <v-row align="center" justify-center>
                  <v-col cols="2">
                    <div class="flex-item2 text-center">
                      <v-checkbox
                        v-model="checkTargetCampaignIds"
                        :value="item.campaignId"
                        :disabled="!checkItemSelectable(item)"
                        hide-details
                        class="ma-0 pa-0"
                      />
                    </div>
                  </v-col>
                  <v-col cols="10">
                    <ul class="flex-content">
                      <li
                        class="flex-item word-break"
                        :data-label="$t('submissionConfirmationCampaignList.headers.campaignName')"
                      >{{ item.campaignName }}</li>
                      <li
                        class="flex-item4"
                        :data-label="$t('submissionConfirmationCampaignList.headers.landingCount')"
                      >{{ number_format(item.creativeLandingCount) }}</li>
                    </ul>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="9" class="text-left" v-if="!isMobile">
        <p
          class="caption text-red-accent-4"
          id="note-1"
        >{{$t('submissionConfirmationCampaignList.notes')}}</p>
      </v-col>
      <v-col cols="3" class="text-right" v-if="!isMobile">
        <v-btn
          v-bind:disabled="disableCreativeSettingButton"
          color="light-blue darken-1 text-white"
          @click="clickCreativeSetting()"
        >{{$t('submissionConfirmationCampaignList.button')}}</v-btn>
      </v-col>
      <v-col cols="12" class="text-right" v-if="isMobile">
        <p
          class="caption text-red-accent-4"
          id="note-1"
        >{{$t('submissionConfirmationCampaignList.notes')}}</p>
        <v-btn
          v-bind:disabled="disableCreativeSettingButton"
          color="light-blue darken-1 text-white"
          @click="clickCreativeSetting()"
        >{{$t('submissionConfirmationCampaignList.button')}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { useFormatters } from '../plugins/format';

export default {
  name: 'submissionConfirmationCampaignList',
  props: ['agencyId', 'advertiserId'],
  setup() {
    const {
      number_format,
      number_format_yen,
      percent_format,
    } = useFormatters();
    return {
      number_format,
      number_format_yen,
      percent_format,
    };
  },
  data: function () {
    return {
      pagination: {
        sortBy: [{ key: 'campaignName', order:'asc' }],
        descending: false,
        rowsPerPage: -1
      },
      submissionConfirmationCampaignListHeaders: [
        {
          title: this.$t('submissionConfirmationCampaignList.headers.campaignName'),
          align: 'center',
          sortable: true,
          key: 'campaignName'
        },
        {
          title: this.$t('submissionConfirmationCampaignList.headers.landingCount'),
          align: 'center',
          key: 'creativeLandingCount',
          sortable: true,
          width: '210'
        }
      ],
      advertiser: {},
      campaignList: [],
      landingCount: {},
      checkTargetCampaignIds: [],
      paramCampaignIds: undefined,
      selectDeliveryStatus: 1,
      disableCreativeSettingButton: true,
      isMobile: false,
      isCpmMode: false,
      errorMessage: undefined,
      isSearching: false
    }
  },
  methods: {
    ...mapActions('campaignDeliveryStatus', ['getCampaignList']),
    initialize: function () {
      if (this.$route.query.deliveryStatus !== undefined) {
        this.selectDeliveryStatus = this.$route.query.deliveryStatus
      } else {
        this.selectDeliveryStatus = 1
      }
      this.previewCampaignList()
    },
    previewCampaignList: function () {
      this.isSearching = true
      const jwtToken = this.$store.getters['auth/jwtToken']
      const selectDeliveryStatus = this.selectDeliveryStatus
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      var url = location.href
      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.indexOf('?'))
      }
      this.$router.replace({
        query: { deliveryStatus: selectDeliveryStatus }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
      this.getCampaignList({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        deliveryStatus: selectDeliveryStatus,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.isSearching = false
          this.errorMessage = undefined
          if (!result) {
            this.campaignList = []
            this.advertiser = {}
            this.checkTargetCampaignIds = []
            return
          }
          this.advertiser = result.advertiser
          this.campaignList = result.campaignList
          this.checkTargetCampaignIds = []
          this.updateButtonState();
        })
        .catch((err) => {
          this.isSearching = false
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
    },
    checkItemSelectable(item) {
      return !this.disableColumn(item.creativeLandingCount);
    },
    disableColumn(creativeLandingCount) {
      return creativeLandingCount > 1000
    },
    changeSort(column) {
      const currentSort = this.pagination.sortBy[0];
      if (currentSort && currentSort.key === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = [{ key: column, order: 'asc' }];
        this.pagination.descending = false;
      }
    },
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    clickCreativeSetting: function () {
      this.$router.push(`/campaignLanding/creativeList/${this.agencyId}/${this.advertiserId}?campaignIds=${this.paramCampaignIds}`)
    },
    changeDeliveyStatus: function () {
      this.checkTargetCampaignIds = []
      this.previewCampaignList()
    },
    clickCampaignPeriod: function () {
      this.$router.push(`/campaignPeriodList/${this.agencyId}/${this.advertiserId}`)
    },
    clickCampaignList: function () {
      this.$router.push(`/campaignList/${this.agencyId}/${this.advertiserId}`)
    },
    updateButtonState() {
      let totalLandingCount = 0;
      for (const campaignId of this.checkTargetCampaignIds) {
        const campaign = this.campaignList.find(c => c.campaignId === campaignId);
        if (campaign) {
          totalLandingCount += campaign.creativeLandingCount;
        }
      }

      this.disableCreativeSettingButton = (this.checkTargetCampaignIds.length === 0) || this.disableColumn(totalLandingCount);
      this.paramCampaignIds = this.checkTargetCampaignIds.length ? this.checkTargetCampaignIds.map(String).join('-') : undefined;
    }
  },
  mounted: function () {
    if (process.env.ProjectCode === '111') {
      this.isCpmMode = true
    }
    this.initialize()
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {},
  watch: {
    checkTargetCampaignIds: {
      handler() {
        this.$nextTick(() => {
          this.updateButtonState();
        });
      },
      deep: true,
      immediate: true
    },
    campaignList: {
      handler() {
        this.checkTargetCampaignIds = [];
        this.$nextTick(() => {
          this.updateButtonState();
        });
      },
      deep: true,
    },
  }
}
</script>
<style scoped>
.campaign-list .break-word-cell {
  max-width: 500px;
  word-wrap: break-word;
}
</style>